import Grid from '@mui/material/Grid';
import {number} from 'prop-types';

import {productShape} from '../../../../../proptypes-shapes';
import ProductDescription from '../ProductDescription/ProductDescription';
import ProductPrice from '../ProductPrice/ProductPrice';
import ProductQuantitySelector from '../ProductQuantitySelector/ProductQuantitySelector';

const ProductCard = ({product, index}) => {
  const primaryLightColor = `${import.meta.env.VITE_MAIN_COLOR}30`;
  const backgroundColor = index % 2 === 0 ? primaryLightColor : '#FFF';

  return (
    <Grid
      item
      xs={12}
      px={{
        xs: 1.5,
        md: 4
      }}
      py={{
        xs: 2,
        md: 3
      }}
      borderRadius={2}
      sx={{backgroundColor}}
    >
      <Grid container flexWrap="wrap" alignItems="center">
        <ProductDescription product={product} />
        <ProductQuantitySelector product={product} />
        <ProductPrice product={product} />
      </Grid>
    </Grid>
  );
};

ProductCard.propTypes = {
  product: productShape.isRequired,
  index: number.isRequired
};

export default ProductCard;
